import { getClientTimezone } from "../types/user";

const sanitizeFilenameSegment = (value: string): string =>
  Array.from(value)
    .map((char) => {
      const code = char.charCodeAt(0);
      if (code < 32 || '<>:"/\\|?*'.includes(char)) {
        return "-";
      }
      return char;
    })
    .join("")
    .trim();

const isValidIanaTimezone = (timezone: string): boolean => {
  if (!timezone) {
    return false;
  }

  try {
    Intl.DateTimeFormat(undefined, { timeZone: timezone });
    return true;
  } catch {
    return false;
  }
};

const getCalendarDateInTimezone = (timezone: string, date: Date = new Date()): string => {
  return new Intl.DateTimeFormat("en-CA", {
    timeZone: timezone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(date);
};

export const formatDownloadTimestamp = (timezone: string, date: Date = new Date()): string => {
  const datePart = getCalendarDateInTimezone(timezone, date);

  const timePart = new Intl.DateTimeFormat("en-GB", {
    timeZone: timezone,
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  })
    .format(date)
    .replace(/:/g, "-");

  const timeZoneName =
    new Intl.DateTimeFormat("en-GB", {
      timeZone: timezone,
      timeZoneName: "short",
    })
      .formatToParts(date)
      .find((part) => part.type === "timeZoneName")?.value ?? timezone;

  return `${datePart}_${timePart}_${sanitizeFilenameSegment(timeZoneName)}`;
};

export const buildUangJalanReportDownloadFilename = (
  readableId: string,
  timezone?: string | null,
  downloadedAt: Date = new Date(),
): string => {
  const candidate = timezone?.trim() || getClientTimezone();
  const resolvedTimezone = isValidIanaTimezone(candidate) ? candidate : "UTC";
  return `${readableId}_${formatDownloadTimestamp(resolvedTimezone, downloadedAt)}.xlsx`;
};
